// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__pRp93","productName":"Table_productName__2da1Z"};